import { getFeatureFlags } from 'utils/feature-flags';
import { useWtrSelector } from 'redux/hooks';
import { getIsEligible } from 'redux/modules/shop-by-list/selectors';
import { useExperiments } from 'components/Experiment/useExperiments';
import { SHOP_BY_LIST } from 'constants/monetateExperiments';

export const useShopByList = () => {
  const { getDecisionById } = useExperiments();
  const isEligible = useWtrSelector(getIsEligible);

  if (!isEligible) {
    return false;
  }

  const { agenticShopping_enableListToBasket: enableShopByListPage } = getFeatureFlags();

  if (!enableShopByListPage) {
    return false;
  }

  const { variant } = getDecisionById(SHOP_BY_LIST.experiment);

  if (variant === SHOP_BY_LIST.variant.default) {
    return false;
  }

  return true;
};
